module.exports = __webpack_public_path__ + "img/infographics.07d3a401.jpg";